import axios from "axios";
// qs 是一个增加了一些安全性的查询字符串解析和序列化字符串的库
import Qs from "qs";
import { Message } from "@hi/ui";
import router from "@/router";
import {
  UACBASE,
  initLanguage,
  INTLLOGINBASE,
  LOGOUTBASE,
} from "@/config/index";

// create an axios instance
const service = axios.create({
  // timeout: 50000, // request timeout
});

// 请求去重容器
const pending = {};

// 请求唯一标识生成方法
const genReqKey = (config) => {
  const { url, method, params, data } = config;
  return [method, url, JSON.stringify(params), JSON.stringify(data)].join("&");
};

// 移除重复请求
const removePending = (config) => {
  const requestKey = genReqKey(config);
  if (pending[requestKey]) {
    pending[requestKey]("取消重复请求");
    delete pending[requestKey];
  }
};

// 添加到请求去重容器
const addPending = (config) => {
  const requestKey = genReqKey(config);
  config.cancelToken = new axios.CancelToken((cancel) => {
    pending[requestKey] = cancel;
  });
};

// request interceptor 设置请求拦截器
service.interceptors.request.use(
  (config) => {
    // removePending(config); // 移除重复请求
    // addPending(config);    // 添加新请求
    config.headers["Language-ID"] =
      localStorage.getItem("lang") || initLanguage;
    return config;
  },
  (error) => {
    // do something with request error
    return Promise.reject(error);
  }
);

// response interceptor 设置响应拦截器
service.interceptors.response.use(
  (response) => {
    // const requestKey = genReqKey(response.config);
    // if (pending[requestKey]) {
    //   delete pending[requestKey]; // 移除已完成的请求
    // }
    const { data = {} } = response;
    // 跳转没有权限页面
    // if (response.status === 200 && response.data.code === "IG004") {
    //   router.push({
    //     path: "/noPermission",
    //   });
    // }
    return data;
  },
  (error) => {
    if (error && error.response) {
      if (+error.response.status === 401) {
        sessionStorage.clear();
        localStorage.clear();
        if (process.env.VUE_APP_BASE_API === "intl") {
          window.location.href = INTLLOGINBASE;
        } else {
          window.location.href = `${UACBASE}/uac-center-pc/login?service=${window.location.origin}/user/sso/login`;
        }
      } else if (+error.response.status === 403) {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = LOGOUTBASE;
      }
    }
    return Promise.reject(error);
  }
);

const GET = (url) => {
  return (params) => {
    return service.get(url, {
      params,
    });
  };
};

const POST = (url, options = {}) => {
  return (params) => {
    return service.post(url, params, options);
  };
};

const POSTFORMDATA = (url) => {
  return (params) => {
    return service.post(url, Qs.stringify(params));
  };
};

const POSTFORMDATA2 = (url) => {
  return (params) => {
    return service.post(url, params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };
};

export { GET, POST, POSTFORMDATA, POSTFORMDATA2 };
